import { getUserData } from "../../utils/auth";
export default {
  usersField: [],
  usersData: [],
  roles: [],
  authUser: getUserData(),
  userProfile: null,
  meuser: null,
  lang: null,
};
